import { LiveElement } from 'live-node-list'

export default class WhereToBuyPopup {
  /**
   * @type {LiveElement}
   */
  trigger = new LiveElement('#where-to-buy-popup-trigger')

  /**
   * @type {LiveElement}
   */
  popup = new LiveElement('#where-to-buy-popup')

  /**
   * @type {LiveElement}
   */
  close = new LiveElement('#where-to-buy-popup-close')

  constructor() {
    this.registerListeners()
  }

  registerListeners() {
    this.trigger.addEventListener('click', () => {
      this.popup.setAttribute('aria-hidden', 'false')
      this.trigger.setAttribute('aria-expanded', 'true')
    })

    this.close.addEventListener('click', () => {
      this.popup.setAttribute('aria-hidden', 'true')
      this.trigger.setAttribute('aria-expanded', 'false')
    })

    document.addEventListener('click', () => {
      this.popup.setAttribute('aria-hidden', 'true')
      this.trigger.setAttribute('aria-expanded', 'false')
    })

    this.trigger.addEventListener('click', e => {
      e.stopPropagation()
    })
    this.popup.addEventListener('click', e => {
      e.stopPropagation()
    })
  }
}
